import {
  Grid,
  MenuItem,
  Select,
  TextField,
  InputLabel
} from "@material-ui/core";
import NavigateBeforeIcon from "@material-ui/icons/NavigateBefore";
import { Button } from "components";
import { usePopup } from "hooks/usePopup";
import { useState, useEffect } from "react";
import ContentLoader from "react-content-loader";
import { Cookies } from "react-cookie";
import printerService from "services/printerService";
import printService from "services/printService";
import { generateBatchExternalCode } from "utils/generateBatchExternalCode";

import { ButtonsContent, StyledBox, Text } from "../../../style";

export const FormView = ({
  action,
  tagQty,
  setTagQty,
  product,
  setProduct,
  products,
  onBack,
  batch,
  handleClose
}) => {
  const { addPopup } = usePopup();
  const isPrePicking = action === "prePicking";
  const [isLoading, setIsLoading] = useState(false);
  const [printers, setPrinters] = useState([]);
  const [loadingPrinters, setLoadingPrinters] = useState(false);
  const cookies = new Cookies();
  const distributionCenterId = cookies.get("distributionCenterId");
  const printerSelected =
    printers.find(item => item.selected) || printers[0] || {};

  const handleChangeTagQty = e => {
    const { value: inputValue } = e.target;
    const value = parseInt(inputValue, 10);
    const isValid = !isNaN(value) && value >= 0;
    setTagQty(isValid ? value : null);
  };

  const handleChangeProduct = ({ target: { value } }) => {
    setProduct(products.find(({ sku }) => sku === value));
  };

  const getPrinters = async () => {
    setLoadingPrinters(true);
    try {
      const { data } = await printerService.getPrinters();

      const mappedPrinters = data.map((printer, index) => ({
        id: printer.osPrinterName,
        name: printer.name,
        delay: 10,
        selected: index === 0,
        count: 0
      }));

      setPrinters(mappedPrinters);
    } catch (error) {
      const errorData = error?.response?.data;
      addPopup({
        type: "error",
        title: "Erro ao carregar impressoras",
        description:
          errorData?.message ||
          errorData?.msg ||
          "Erro ao carregar lista de impressoras"
      });
    }
    setLoadingPrinters(false);
  };

  const onSelectPrinter = printerName => {
    setPrinters(state =>
      state.map(item => ({ ...item, selected: item.name === printerName }))
    );
  };

  const mapPrinters = printerName => {
    const printer = printers.find(item => item.name === printerName);
    return printer?.id || "";
  };

  const getBatchPrinter = () => {
    return printerSelected?.id || "";
  };

  const isValid = !!tagQty && (isPrePicking ? !!product : true);

  const handleConfirm = async () => {
    setIsLoading(true);
    try {
      const request = {
        prePicking: () =>
          printService.printTagsV2({
            sku: product.sku,
            skuName: product.name,
            portionType: product.portionType,
            purchaseValue: product.purchaseValue,
            productBaseId: batch.product?.id,
            productBaseName: batch.product?.name,
            tagQuantity: tagQty,
            batchId: batch.id,
            batchExternalCode: generateBatchExternalCode(batch),
            uniqueTag: true,
            printer: mapPrinters(printerSelected?.name),
            distributionCenterId
          }),
        batch: () => {
          return printService.printBatchTag(batch.id, {
            qty: Number(tagQty),
            isReceipt: true,
            printer: getBatchPrinter(),
            distributionCenterId
          });
        }
      }[action];

      await request();

      addPopup({
        type: "success",
        title: "Tudo certo!",
        description: "Etiquetas enviadas para fila de impressão"
      });
      handleClose();
    } catch (error) {
      const errorData = error?.response?.data;
      addPopup({
        type: "error",
        title: "Erro ao imprimir",
        description: errorData?.message || errorData?.msg
      });
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getPrinters();
  }, []);

  return (
    <>
      <StyledBox>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Text style={{ marginBottom: "0.5rem" }}>
              Quantas etiquetas gostaria de imprimir?
            </Text>
            <TextField
              variant="outlined"
              type="number"
              onChange={handleChangeTagQty}
              value={tagQty}
              label={`Quantidade`}
              fullWidth
            />
          </Grid>
          {isPrePicking && (
            <>
              <Grid item xs={12}>
                <Text style={{ marginBottom: "0.5rem" }}>
                  Qual é o porcionamento(SKU)?
                </Text>

                <Select
                  variant="outlined"
                  fullWidth
                  value={product?.sku}
                  onChange={handleChangeProduct}
                >
                  {products.map(item => (
                    <MenuItem key={item.id} value={item.sku}>
                      {item.name}
                    </MenuItem>
                  ))}
                </Select>
              </Grid>
            </>
          )}
          <Grid item xs={12}>
            <InputLabel>Impressora</InputLabel>
            {loadingPrinters ? (
              <ContentLoader speed={1} width={316} height={56}>
                <rect x="0" y="0" rx="4" ry="4" width="316" height="56" />
              </ContentLoader>
            ) : (
              <Select
                fullWidth
                variant="outlined"
                value={printerSelected?.name || ""}
                onChange={e => onSelectPrinter(e.target.value)}
              >
                {printers.map(printer => (
                  <MenuItem key={printer.name} value={printer.name}>
                    {printer.name}
                  </MenuItem>
                ))}
              </Select>
            )}
          </Grid>
        </Grid>
      </StyledBox>
      <ButtonsContent
        display="flex"
        justifyContent="flex-end"
        alignItems="flex-end"
        style={{ flexDirection: "row" }}
      >
        <Button
          onClick={onBack}
          disabled={isLoading}
          fullWidth
          startIcon={<NavigateBeforeIcon />}
        >
          Voltar
        </Button>
        <Button
          variant="contained"
          onClick={handleConfirm}
          disabled={!isValid}
          isLoading={isLoading}
          fullWidth
        >
          Avançar
        </Button>
      </ButtonsContent>
    </>
  );
};
